import ProductPage from "components/ProductPage";
import { getListVirtualStores } from "../data";

function SaborDosDeuses() {
  const data = getListVirtualStores().filter(
    (item) => item.productId === "#L05"
  );
  return <ProductPage pageData={data} />;
}

export default SaborDosDeuses;
